import React, { useEffect, useState} from "react";
import { Variables, variables } from '../Variables.js';
import imageLogo from '../img/logo.png';
import barLogo from '../img/barchart.png';
import close from '../img/close.png';
import AllTeams from './AllTeams';
import Points from './Stats/Points';
import PointsVsTeam from './Stats/PointsVsTeam';
import Rebounds from './Stats/Rebounds';
import ReboundsVsTeam from './Stats/ReboundsVsTeam';
import Assists from './Stats/Assists';
import AssistsVsTeam from './Stats/AssistsVsTeam';
import PointsRebounds from './Stats/PointsRebounds';
import PointsReboundsVsTeam from './Stats/PointsReboundsVsTeam';
import PointsAssists from './Stats/PointsAssists';
import PointsAssistsVsTeam from './Stats/PointsAssistsVsTeam';
import PointsReboundsAssists from './Stats/PointsReboundsAssists';
import PointsReboundsAssistsVsTeam from './Stats/PointsReboundsAssistsVsTeam';
import TeamNameHeader from './Stats/TeamNameHeader';
import TeamStats from './Stats/TeamStats';
import LastFive from './Stats/LastFive';
import { useNavigate } from "react-router-dom";
import Modal from "react-modal"; 
import Gametoolbar from "./Games/GamesToolbar.js";

function Stats() {

    const [info, setState] = useState([])
    const [vsTeamStats, setVsTeamStats] = useState([])
    const [teamInfo, setTeamInfo] = useState([])
    const [playerInjuryInfo, setInjuryInfo] = useState([])
    const [gameExists, setGameExists] = useState(true)
    const [props, setProps] = useState([])
    const navigate = useNavigate()
    const [isPopupOpen, setPopupOpen] = useState(false)

    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("playerId")
    const playerName = queryParameters.get("playerName")
    const playerTeamId = queryParameters.get("playerTeamId")
    const playerTeamAbrev = queryParameters.get("playerTeamAbrev")
    const teamAbrev = queryParameters.get("teamAbrev")
    const teamName = queryParameters.get("teamName")
    const teamId = queryParameters.get("teamId")
    const playerExp = queryParameters.get("playerExp")

    const points_exists = queryParameters.has('points')
    const rebounds_exists = queryParameters.has('rebounds')
    const assists_exists = queryParameters.has('assists')
    const pr_exists = queryParameters.has('pr')
    const pa_exists = queryParameters.has('pa')
    const pra_exists = queryParameters.has('pra')

    const team_exists = queryParameters.has('teamName')

    const points = queryParameters.get('points')
    const rebounds = queryParameters.get('rebounds')
    const assists = queryParameters.get('assists')
    const pr = queryParameters.get('pr')
    const pa = queryParameters.get('pa')
    const pra = queryParameters.get('pra')

    //(GET)
    const fetchPlayerData = () => {
        fetch(variables.API_URL + 'Stats/getStats/' + id)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch player data');
                }
                return response.json()
            })
            .then(data => {
                setState(data)
                //document.write(JSON.stringify(data));
            }).catch(error => {
                console.error("Error fetching player data: ", error);
                navigate('/error');  
            });
        
    }

    const fetchPlayerVsTeamData = () => {
        
        fetch(variables.API_URL + 'Stats/getStatsVsTeam/' + id + '/' + playerTeamId + '/' + playerTeamAbrev + '/' + teamId + '/' + teamAbrev + '/' + playerExp + '/' + variables.CURR_NBA_SEASON)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch versus data');
                }
                return response.json()

            })
            .then(data => {
                setVsTeamStats(data)
                //Export Response Body for Testing
                //document.write(JSON.stringify(data));

            }).catch(error => {
                console.error("Error fetching player data: ", error);
                navigate('/error');
            });
    }

    //API Request for Selected Team Info (GET)
    const fetchTeamInfo = () => {
        fetch(variables.API_URL + 'Player/getNBATeam/' + teamId)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch team info');
                }
                return response.json()
            })
            .then(data => {
                setTeamInfo(data)
                //document.write(JSON.stringify(data));
            }).catch(error => {
                console.error("Error fetching team data: ", error);
                navigate('/error');
            });
    }

    //API Request for Player Injury News (GET)
    const fetchPlayerInjuryInfo = () => {
        fetch(variables.API_URL + 'Player/getNBAPlayerInjury/' + id)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch injury info');
                }
                return response.json()
            })
            .then(data => {
                setInjuryInfo(data)
                //document.write(JSON.stringify(data));
            }).catch(error => {
                console.error("Error fetching injury info: ", error);
                navigate('/error');
            });
    }

    const checkGameExists = (vsTeamStats) => {

        if (vsTeamStats.totGameCount == 0) {
            setGameExists(false)
            //reroute to error page
            //navigate('/');
        }


    }

    const togglePopup = () => {
        setPopupOpen(!isPopupOpen);
    };

    //Run GET on page load
    useEffect(() => {
        //Redirect to Home if invalid Player Name or Id is provided
        if (id == "" || id == "undefined" || playerTeamId == "") {
            navigate('/error/?errorCode=2323');  
        }
        fetchPlayerData();
        fetchPlayerInjuryInfo();
        //if team paramater is provided, provide stats for matchup
        if (team_exists) {
            
            //Redirect to Home if no prop is provided (team matchup only available for props)
            if ((!points_exists && !rebounds && !assists && !pr && !pa && !pra) || teamId == "" || teamId == "undefined" ) {
                navigate('/error');
            }
            fetchPlayerVsTeamData();
            fetchTeamInfo();
            
            
        }

    }, [])

    useEffect(() => {
        if (team_exists) {
            checkGameExists(vsTeamStats)
        }
    }, [vsTeamStats])

    const Widget = ({ label, onClick, isSelected }) => {
        const widgetClass = `widget ${isSelected ? 'widget-selected' : ''}`;
        return (
            <button className={widgetClass} onClick={onClick}>
                {label}
            </button>
        );
    };

    const WidgetList = () => {
        const [selectedWidgets, setSelectedWidgets] = useState([]);
        const validWidgetNames = ['points', 'rebounds', 'assists', 'pr', 'pa', 'pra'];

        useEffect(() => {
            const searchParams = new URLSearchParams(window.location.search);
            const initialSelectedWidgets = [];

            for (let [key, value] of searchParams) {
                if (validWidgetNames.includes(key) && value === 'true') {
                    initialSelectedWidgets.push(key);
                }
            }

            setSelectedWidgets(initialSelectedWidgets);
        }, []);

        const handleWidgetClick = (label) => {
            setSelectedWidgets(prevSelectedWidgets => {
                const updatedSelectedWidgets = prevSelectedWidgets.includes(label) ?
                    prevSelectedWidgets.filter(widget => widget !== label) :
                    [...prevSelectedWidgets, label];

                const searchParams = new URLSearchParams(window.location.search);
                validWidgetNames.forEach(widget => {
                    if (updatedSelectedWidgets.includes(widget)) {
                        searchParams.set(widget, 'true');
                    } else {
                        searchParams.delete(widget);
                    }
                });

                const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
                window.location.href = newUrl;

                return updatedSelectedWidgets;
            });
        };

        return (
            <div>
                {validWidgetNames.map((label) => (
                    <Widget
                        key={label}
                        label={label}
                        isSelected={selectedWidgets.includes(label)}
                        onClick={() => handleWidgetClick(label)}
                    />
                ))}
            </div>
        );
    };

    return (
    <div> 
        <div className="props">
            <div id="viewport" className="l-viewport">
                <div className="l-wrapper">
                <header className="header">
                    <a className="header--logo" href="/">
                        <img src={imageLogo} alt="Global" />
                        <p>NPA</p>
                    </a>
                </header>
                
                <ul className="stats-home-ul">
                    <li className="header-stats">
                    
                        <div className="propOptions">                          
                            <center>
                                <p className="statsGameToolbar"></p>
                                <Gametoolbar />
                                {<center><WidgetList/></center>}
                                <p className="games">
                                    
                                        <img src={info.nbaComHeadshot} className="headshot" />                                       
                                        <span class="games_list">
                                            <p>Recent Injury Designation</p>
                                                <ul>
                                                    {Object.values(playerInjuryInfo).map((item) => {

                                                        var dateString = item.injDate;
                                                        var year = dateString.substring(0, 4);
                                                        var month = dateString.substring(4, 6);
                                                        var day = dateString.substring(6, 8);

                                                        return (<li>{month + "-" + day + "-" + year} {item.designation}</li>);
                                                })}


                                            </ul>
                                        </span>
                                        
                               </p>
                            </center>
                            <img onClick={togglePopup} className="header--barLogo" src={barLogo} alt="Clickable Icon" />
                            <p className="centered">#{info.jerseyNum} {info.team} {info.pos} (EXP: {info.exp}YR)</p>
                            <h2>{playerName} {variables.CURR_NBA_SEASON} Stats</h2>
                            <Modal isOpen={isPopupOpen} onRequestClose={togglePopup} contentLabel="Last Five" style={{ content: { margin: 'auto', width: '50%', height: 'auto', backgroundColor: "#42423e" } }} >
                                <img onClick={togglePopup} className="closeIcon" src={close} alt="Close Icon"/>
                                <LastFive isPopupOpen={isPopupOpen} data={id}></LastFive>
                            </Modal>

                            <div className="work-request--options">
                                <span className="options-a">
                                    <label htmlFor="ppg">
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                            viewBox="0 0 150 111" xmlSpace="preserve">
                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                            </g>
                                        </svg>
                                        {info.stats && info.stats.pts} PPG
                                    </label>
                                  
                                    <label htmlFor="fgp">
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                            viewBox="0 0 150 111" xmlSpace="preserve">
                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                            </g>
                                        </svg>
                                        {info.stats && info.stats.fgp}% FGP
                                    </label>
                             
                                    <label htmlFor="ftp">
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                            viewBox="0 0 150 111" xmlSpace="preserve">
                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                            </g>
                                        </svg>
                                        {info.stats && info.stats.ftp}% FTP
                                    </label>
                                    <label htmlFor="pr">
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                            viewBox="0 0 150 111" xmlSpace="preserve">
                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                            </g>
                                        </svg>
                                        {info.stats && info.stats.tptfgp}% 3PP
                                    </label>

                                </span>
                                <span className="options-a">

                                    <label htmlFor="reb">
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                            viewBox="0 0 150 111" xmlSpace="preserve">
                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                            </g>
                                        </svg>
                                        {info.stats && info.stats.reb} RPG
                                    </label>

                                    <label htmlFor="fgp">
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                            viewBox="0 0 150 111" xmlSpace="preserve">
                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                            </g>
                                        </svg>
                                        {info.stats && (parseFloat(info.stats.reb)-parseFloat(info.stats.offReb)).toFixed(2)} DRPG
                                    </label>

                                    <label htmlFor="ftp">
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                            viewBox="0 0 150 111" xmlSpace="preserve">
                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                            </g>
                                        </svg>
                                        {info.stats && info.stats.offReb} ORPG
                                    </label>
                                    <label htmlFor="apg">
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                            viewBox="0 0 150 111" xmlSpace="preserve">
                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                            </g>
                                        </svg>
                                        {info.stats && info.stats.ast} APG
                                    </label>
                                </span>
                            </div>
                            {(points_exists || rebounds || assists || pr || pa || pra) &&
                                <form action={`/stats/`} className="work-request">
                                    <AllTeams />
                                    <input type="hidden" name="playerId" id="playerId" value={id} />
                                    <input type="hidden" name="playerTeamId" id="playerTeamId" value={playerTeamId} />
                                    <input type="hidden" name="playerName" id="playerName" value={playerName} />
                                    <input type="hidden" name="playerTeamAbrev" id="playerTeamAbrev" value={playerTeamAbrev} />
                                    <input type="hidden" name="playerPos" id="playerPos" value={info.pos} />
                                    <input type="hidden" name="playerExp" id="playerExp" value={info.exp} />
                                    {points_exists && <input type="hidden" name="points" id="points" value={points} />}
                                    {rebounds_exists && <input type="hidden" name="rebounds" id="rebounds" value={rebounds} />}
                                    {assists_exists && <input type="hidden" name="assists" id="assists" value={assists} />}
                                    {pr_exists && <input type="hidden" name="pr" id="pr" value={pr} />}
                                    {pa_exists && <input type="hidden" name="pa" id="pa" value={pa} />}
                                    {pra_exists && <input type="hidden" name="pra" id="pra" value={pra} />}
                                </form>
                            }
                        </div>
                    </li>                   
                </ul>   
                        
                        
                        {team_exists && <TeamStats data={teamInfo} />}
                        {team_exists && <TeamNameHeader data={gameExists} />}

                        {points_exists && !team_exists && <Points data={info} />}
                        {points_exists && team_exists && <PointsVsTeam data={vsTeamStats} />}                    
                
                        {rebounds_exists && !team_exists && <Rebounds data={info} />}
                        {rebounds_exists && team_exists && <ReboundsVsTeam data={vsTeamStats} />}

                        {assists_exists && !team_exists && <Assists data={info} />}
                        {assists_exists && team_exists && <AssistsVsTeam data={vsTeamStats} />}
                   
                        {pr_exists && !team_exists && <PointsRebounds data={info} />}
                        {pr_exists && team_exists && <PointsReboundsVsTeam data={vsTeamStats} />}
                                     
                        {pa_exists && !team_exists && <PointsAssists data={info} />}
                        {pa_exists && team_exists && <PointsAssistsVsTeam data={vsTeamStats} />}

                        {pra_exists && !team_exists && <PointsReboundsAssists data={info} />}
                        {pra_exists && team_exists && <PointsReboundsAssistsVsTeam data={vsTeamStats} />}
                
                </div>
            </div>  
        </div>
    </div>
    )
};
export default Stats;